/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import classNames from "classnames";
import _ from "underscore";
import { DateRangeCalendar } from "./date_range_calendar.jsx";

// Functional component for the menu item buttons
const MenuItemButton = props => {
  const klasses = classNames('em-dropdown-item', props.className,
    {'active': props.active});

  // Extract special props for MenuItemButton
  const {
    active
  } = props;
  const {
    index
  } = props;
  const {
    label
  } = props;

  const buttonProps = _.omit(props, 'active', 'index', 'label', 'className');

  return <button id={`em-filter-menu-date-selector-preset-${  index}`}
            autoFocus={active}
            className={klasses}
            tabIndex="0"
            role="menuitem"
            aria-selected={active}
            {...buttonProps}>
    {label}
  </button>;
};

export var FilterMenuDateSelector = (function() {
  FilterMenuDateSelector = class FilterMenuDateSelector extends React.Component {
    static initClass() {
      this.propTypes = {
        // Initial date selected, as a moment object. Note that the time part does not matter
        start: PropTypes.instanceOf(moment),
        // Number of days selected
        days: PropTypes.number,
        // Preset options
        presets: PropTypes.arrayOf(PropTypes.shape({
          // Start date for this range, as a moment object. Time part is ignored
          start: PropTypes.instanceOf(moment),
          // Number of days in this range
          days: PropTypes.number,
          // Label for this range
          label: PropTypes.string
        })
        ),
        // Platform default calendar view
        defaultCalendarView: PropTypes.shape({
            days: PropTypes.number.isRequired,
            label: PropTypes.string.isRequired
        }),
        // Custom range label
        selectRangeLabel: PropTypes.string,
        // Momentjs format string for date label on button
        dateLabelFormat: PropTypes.string,
        // Callback when a new date range is selected, with two params
        //   start: moment object containing the selected start date
        //   end: moment object containing the selected end date
        onDateSelected: PropTypes.func
      };
  
      this.defaultProps = {
        start: moment(),
        days: 1,
        presets: [
          {start: moment(), days: 1, label: "Today"},
          {start: moment(), days: 7, label: "Next 7 Days"},
          {start: moment(), days: 30, label: "Next 30 Days"}
        ],
        defaultCalendarView: undefined,
        selectRangeLabel: "Select date on a calendar",
        dateLabelFormat: 'MMMM D, YYYY',
        onDateSelected(start, days) {}
      };
       // empty
    }

    constructor(props) {
      super(props);
      this.componentDidMount = this.componentDidMount.bind(this);
      this.componentWillUnmount = this.componentWillUnmount.bind(this);
      this.componentDidUpdate = this.componentDidUpdate.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
      this.setMenuRef = this.setMenuRef.bind(this);
      this.setButtonRef = this.setButtonRef.bind(this);
      this.setCalendarRef = this.setCalendarRef.bind(this);
      this.toggleMenu = this.toggleMenu.bind(this);
      this.handleMenuButtonClick = this.handleMenuButtonClick.bind(this);
      this.handleMenuButtonKeyDown = this.handleMenuButtonKeyDown.bind(this);
      this.changeSelectedItem = this.changeSelectedItem.bind(this);
      this.handleMenuKeyDown = this.handleMenuKeyDown.bind(this);
      this.renderButton = this.renderButton.bind(this);
      this.selectDateRange = this.selectDateRange.bind(this);
      this.handlePresetClick = this.handlePresetClick.bind(this);
      this.handleSelectRangeClick = this.handleSelectRangeClick.bind(this);
      this.handleDateRangeSelected = this.handleDateRangeSelected.bind(this);
      this.renderPresets = this.renderPresets.bind(this);
      this.renderCalendar = this.renderCalendar.bind(this);
      this.renderMenu = this.renderMenu.bind(this);
this.render = this.render.bind(this);

      this.menuRef = null;
      this.buttonRef = null;
      this.calendarRef = null;

      // Flags to force a refocus on update
      this.focusButton = false;
      this.focusCalendar = false;

      // Build initial state, normalizing the start and end dates
      this.state = this.getInitialState(props);
    }

    getInitialState(props) {
      const updated_presets = _.clone(props.presets);

      if (props.defaultCalendarView) {
        updated_presets.push({ start: moment(), days: props.defaultCalendarView.days, label: props.defaultCalendarView.label });
      }

      const selectedPreset = this.findSelectedPreset(props, updated_presets);
      const calendarOpened = selectedPreset === props.presets.length;

      return {
        start:          moment(props.start).startOf('day'),
        end:            __guard__(moment(props.end), x => x.startOf('day')),
        opened:         false,
        calendarOpened,
        // Index of "active" preset selection, or length (count + 1) for the "custom range" item
        selectedPreset,
        presets: updated_presets
      };
    }

    // Find the first matching preset for the start and end provided in props
    findSelectedPreset(props, presets, start = null, end = null) {
      if (!start) { ({
        start
      } = props); }
      if (!end) { ({
        end
      } = props); }

      const days = end.diff(start, 'd') + 1;

      for (let index = 0; index < presets.length; index++) {
        const preset = presets[index];
        if (preset.start.isSame(start, 'day') && (preset.days === days)) {
          return index;
        }
      }

      // Default to "choose date on calendar"
      return presets.length;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      // Reset internal state if the new start date or days props have changed
      if (!props.start.isSame(nextProps.start, 'day') || !(props.end != null ? props.end.isSame(nextProps.end, 'day') : undefined)) {
        return this.setState(this.getInitialState(nextProps));
      }
    }

    componentDidMount() {
      // Register click listener on document, to hide menu when clicking outside of it
      return document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
      // Remove click listener on document
      return document.removeEventListener('click', this.handleClickOutside);
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevState.selectedPreset !== this.state.selectedPreset) {
        // Force focus on the appropriate element
        // This cheats and sets focus by ID
        __guard__(this.menuRef.querySelector(`#em-filter-menu-date-selector-preset-${  this.state.selectedPreset}`), x => x.focus());
      }

      if ((this.state.selectedPreset === this.props.presets.length) && this.focusCalendar) {
        // Force focus on the calendar, if it's visible
        if (this.calendarRef) {
          this.focusCalendar = false;
          __guard__(this.calendarRef.querySelectorAll('.DayPicker-NavButton[tabindex="0"]')[0], x1 => x1.focus());
        }
      }


      if (!this.state.opened && (prevState.opened !== this.state.opened)) {
        if (this.focusButton) {
          this.focusButton = false;
          // Menu is closing, so force focus on the button as soon as possible, but
          // not immediately to prevent escape from closing the whole menu
          const theButton = this.buttonRef;
          if (theButton != null) { return setTimeout((() => theButton.focus()), 0); }
        }
      }
    }

    handleClickOutside(event) {
      if (!event.defaultPrevented && this.menuRef && !this.menuRef.contains(event.target)) {
        return this.toggleMenu(false);
      }
    }

    setMenuRef(ref) { return this.menuRef = ref; }
    setButtonRef(ref) { return this.buttonRef = ref; }
    setCalendarRef(ref) { return this.calendarRef = ref; }

    // Utility method to toggle menu
    //
    // If force is set, forces to that state
    toggleMenu(force) {
      if (force == null) { force = undefined; }
      const newOpened = (force != null) ? force : !this.state.opened;

      const nextState =
        {opened: newOpened};

      if (newOpened) {
        // If opening, reset the active index to the most appropriate one
        if (newOpened !== this.state.opened) {
          nextState.selectedPreset = this.findSelectedPreset(this.props, this.state.presets, this.state.start, this.state.end);
          nextState.calendarOpened = nextState.selectedPreset === this.state.presets.length;
        }
      }

      return this.setState(nextState);
    }

    handleMenuButtonClick(event) {
      return this.toggleMenu();
    }

    handleMenuButtonKeyDown(event) {
      if (event.defaultPrevented) { return; }

      switch (event.key) {
        // Open the menu with an up/down arrow key press
        case 'Up': case 'ArrowUp': case 'Down': case 'ArrowDown':
          event.preventDefault();
          return this.toggleMenu();
        case 'Escape':
          if (this.state.opened) {
            event.preventDefault();
            return this.toggleMenu(false);
          }
          break;
      }
    }

    // Chagne the selected menu item by the offset, should be -1 or 1
    changeSelectedItem(offset) {
      let nextIndex = this.state.selectedPreset + offset;

      // Clamp to items
      if (nextIndex < 0) {
        nextIndex = 0;
      } else if (nextIndex > this.state.presets.length) {
        nextIndex = this.state.presets.length;
      }

      return this.setState({selectedPreset: nextIndex});
    }

    // Handle keypresses while focused in the menu
    handleMenuKeyDown(event) {
      if (event.defaultPrevented) { return; }

      switch (event.key) {
        case 'Up': case 'ArrowUp':
          // Move selection up
          event.preventDefault();
          return this.changeSelectedItem(-1);

        case 'Down': case 'ArrowDown':
          // Move selection down
          event.preventDefault();
          return this.changeSelectedItem(1);

        case 'Escape':
          // Close menu and force focus on the button
          this.focusButton = true;
          event.preventDefault();
          return this.toggleMenu(false);

        case 'Tab':
          // Close menu, but allow focusing the next item
          var focusedElement = document.activeElement;
          if (focusedElement.classList.contains('DayPicker-Day') && !event.shiftKey) {
            this.focusButton = false;
            return this.toggleMenu(false);
          }
          break;
      }
    }

    renderButton() {
      const label = `${this.state.start.format(this.props.dateLabelFormat)  } - ${  this.state.end.format(this.props.dateLabelFormat)}`;

      return <div>
        <i className="fas fa-sort-down"></i>
        <button type="button"
                ref={this.setButtonRef}
                onClick={this.handleMenuButtonClick}
                onKeyDown={this.handleMenuButtonKeyDown}
                className="em-select-fallback em-ellipsis placeholder"
                aria-haspopup="true"
                aria-controls="em-filter-menu-date-selector-menu"
                aria-expanded={this.state.opened}
                aria-label={`When: ${  label}`}>
          {label}
        </button>
      </div>;
    }

    selectDateRange(start, end, index = null) {
      // Update our state, and hide the menu once the selection is made
      this.focusButton = true;
      this.setState({
        start,
        end,
        opened: false
      });

      // Notify of the date change
      return (typeof this.props.onDateSelected === 'function' ? this.props.onDateSelected(start, end) : undefined);
    }

    // This function returns a function with index bound appropriately, to apply the current preset
    handlePresetClick(index) {
      return event => {
        event.preventDefault();

        const preset = this.state.presets[index];
        this.setState({
          selectedPreset: index,
          calendarOpened: false
        });

        // Calculate end date and update selected date range
        // The range returned is *inclusive*, and time is ignored completely, so a preset defined as 1 day means
        // the start and end dates are the same.
        const start = moment(preset.start);

        const {
          days
        } = preset;

        const end = start.add(days - 1, 'days');

        return this.selectDateRange(preset.start, end);
      };
    }

    handleSelectRangeClick(event) {
      event.preventDefault();

      this.focusCalendar = true;

      return this.setState({
        selectedPreset: this.state.presets.length,
        calendarOpened: true
      });
    }

    // Callback when the user selects a range using the calendar
    handleDateRangeSelected(start, end) {
      return this.selectDateRange(start, end);
    }

    renderPresets() {
      return (() => {
        const result = [];
        for (let index = 0; index < this.state.presets.length; index++) {
          const preset = this.state.presets[index];
          const isSelected = index === this.state.selectedPreset;

          result.push(<MenuItemButton key={index}
                            index={index}
                            active={isSelected}
                            onClick={this.handlePresetClick(index)}
                            role="menuitem"
                            label={preset.label} />);
        }
        return result;
      })();
    }
    renderCalendar() {
      if (this.state.calendarOpened) {
        return <DateRangeCalendar elementRef={this.setCalendarRef}
                            start={this.state.start}
                            end={this.state.end}
                            onDateRangeSelected={this.handleDateRangeSelected}
        />;
      }
    }

    renderMenu() {
      return <div id="em-filter-menu-date-selector-menu"
            className="em-multi-select-menu em-dropdown-container"
            onKeyDown={this.handleMenuKeyDown}>
        <fieldset className="em-multi-select-menuitems"
                  role="menu"
                  aria-activedescendant={`em-filter-menu-date-selector-preset-${  this.state.selectedPreset}`}>
          <legend className="sr-only">Select Date Range</legend>
          {this.renderPresets()}
          <MenuItemButton index={this.state.presets.length}
                          onClick={this.handleSelectRangeClick}
                          active={this.state.presets.length == this.state.selectedPreset}
                          className="em-dropdown-item-submenu"
                          aria-haspopup="true"
                          aria-expanded={this.state.calendarOpened}
                          aria-controls="em-filter-menu-date-selector-calendar"
                          label={this.props.selectRangeLabel} />
          {this.renderCalendar()}
        </fieldset>
      </div>;
    }

    render() {
      const klasses = classNames('em-select-input',
        {'em-multi-select-container--open': this.state.opened});

      return <div className={klasses} ref={this.setMenuRef} tabIndex={-1}>
        {this.renderButton()}
        {this.state.opened && this.renderMenu()}
      </div>;
    }
  };
  FilterMenuDateSelector.initClass();
  return FilterMenuDateSelector;
}());

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}